/**
 * Aspect ratio constants for image generation
 */

// NS 1.1 Aspect ratio configuration
export interface AspectRatioConfig {
  ratio: number
  width: number
  height: number
  label: string
}

// NS 1.1 Aspect ratio mappings with dimensions
export const NS11_ASPECT_RATIOS: AspectRatioConfig[] = [
  // 📌 Dọc
  { ratio: 9 / 16, width: 768, height: 1365, label: '9:16' },
  { ratio: 3 / 4, width: 768, height: 1024, label: '3:4' },
  { ratio: 2 / 3, width: 768, height: 1152, label: '2:3' },

  // 📌 Vuông
  { ratio: 1, width: 1024, height: 1024, label: '1:1' },

  // 📌 Ngang
  { ratio: 4 / 3, width: 1365, height: 1024, label: '4:3' },
  { ratio: 16 / 9, width: 1536, height: 864, label: '16:9' },
  { ratio: 21 / 9, width: 1920, height: 823, label: '21:9' },
]

// Get aspect ratio by index
export function getAspectRatioByIndex(index: number): AspectRatioConfig {
  return NS11_ASPECT_RATIOS[index] || NS11_ASPECT_RATIOS[10] // Default to 1:1
}

// Get default aspect ratio index (1:1)
export function getDefaultAspectRatioIndex(): number {
  return NS11_ASPECT_RATIOS.findIndex(r => r.ratio === 1.0)
}

// Nano Banana Aspect ratio mappings with dimensions
export const NANO_BANANA_ASPECT_RATIOS: AspectRatioConfig[] = [
  { ratio: 1 / 1, width: 1024, height: 1024, label: '1:1' },
  { ratio: 2 / 3, width: 683, height: 1024, label: '2:3' },
  { ratio: 3 / 2, width: 1024, height: 683, label: '3:2' },
  { ratio: 3 / 4, width: 768, height: 1024, label: '3:4' },
  { ratio: 4 / 3, width: 1024, height: 768, label: '4:3' },
  { ratio: 9 / 16, width: 576, height: 1024, label: '9:16' },
  { ratio: 16 / 9, width: 1024, height: 576, label: '16:9' },
  { ratio: 21 / 9, width: 1024, height: 439, label: '21:9' },
]

// Get Nano Banana aspect ratio by index
export function getNanoBananaAspectRatioByIndex(index: number): AspectRatioConfig {
  return NANO_BANANA_ASPECT_RATIOS[index] || NANO_BANANA_ASPECT_RATIOS[0] // Default to 1:1
}

// Get default Nano Banana aspect ratio index (1:1)
export function getDefaultNanoBananaAspectRatioIndex(): number {
  return NANO_BANANA_ASPECT_RATIOS.findIndex(r => r.ratio === 1.0)
}
